import type { LucideIcon } from 'lucide-react';

/** Variation types for UI components */
export type Variation =
  | 'primary'
  | 'secondary'
  | 'outline'
  | 'solidPrimary'
  | 'leavesPrimary'
  | 'white'
  | 'whiteOutline'
  | 'ghost'
  | 'adminPrimary'
  | 'ghostBorder'
  | 'dangerOutline'
  | 'destructive'
  | 'danger'
  | 'success';
/** Size types for UI components */
export type Size = 'xs' | 'sm' | 'md' | 'lg';
// For color-themed variations (success, warning, error, etc.)
export enum Tone {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  ACCENT = 'accent',
  WARNING = 'warning',
  ERROR = 'error',
  NEUTRAL = 'neutral',
  SOFT_BLUE = 'softBlue',
  SOFT_GRAY = 'softGray',
}

/** Mapping types for variations and sizes */
export type VariationMap<T> = Record<Variation, T>;
/** Mapping types for sizes */
export type SizeMap<T> = Record<Size, T>;
/** Mapping types for tones */
export type ToneMap<T> = Record<Tone, T>;

/** Props for components that have an icon prefix or suffix */
export interface IconAdornmentProps {
  IconSuffix?:
    | LucideIcon
    | ((props: React.ComponentProps<LucideIcon>) => React.ReactElement)
    | null;
  IconPrefix?: LucideIcon | null;
}

export interface ReactChildren {
  children: React.ReactNode;
}
